import { createWebHistory, createRouter } from "vue-router";

const routes = [
  {
    path: "/",
    name: "login",
    component: () => import('@/views/Login.vue'),
    meta: {
        title: process.env.VUE_APP_APPNAME,
        auth: false
    }
  },
  {
    path: "/searcher",
    component: () => import('@/views/Home.vue'),
    meta: {
        title: process.env.VUE_APP_APPNAME,
        auth: true
    },
    children: [
      {
        path: "/searcher",
        name: "searcher",
        components: {
            main: () => import('@/views/subviews/Searcher.vue')
        }
      },
      {
        path: "/result",
        name: "result",
        components: {
            main: () => import('@/views/subviews/Result.vue')
        }
      },
      {
        path: "/detail",
        name: "detail",
        components: {
            main: () => import('@/views/subviews/Detail.vue')
        }
      },
      {
        path: "/upload",
        name: "upload",
        components: {
            main: () => import('@/views/subviews/Upload.vue')
        }
      },
      {
        path: "/management/users",
        name: "management_users",
        components: {
            main: () => import('@/views/management/Users.vue')
        }
      },
      {
        path: "/myfiles",
        name: "myfiles",
        components: {
          main: () => import('@/views/subviews/Myfiles.vue')
        }
      },
      {
        path: "/department",
        name: "department",
        components: {
          main: () => import('@/views/subviews/Department.vue')
        }
      }
    ]
  },
  {
      path: "/:pathMatch(.*)*",
      name: "error",
      component: () => import('@/views/Error'),
      meta: {
          error: true
      }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
